import { render, staticRenderFns } from "./PaymentMethodInfoItem.vue?vue&type=template&id=9cea86b8"
import script from "./PaymentMethodInfoItem.vue?vue&type=script&lang=js"
export * from "./PaymentMethodInfoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports